export const createStyles = (theme?: any) => {
  return {
    title: {
      fontWeight: 500,
      fontSize: '0.875rem',
      color: theme.palette.text.primary,
      letterSpacing: '0.1px',
      lineHeight: '150%',
    },
  };
};
